module.exports = __webpack_public_path__ + "static/media/img_oa.c1ec4880.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/solution/images/img_oa.png
// module id = 382
// module chunks = 4